import { Moment } from 'moment'

export const formatMomentDateToSendToAPI = (momentDate: Moment) => {
  const yearToSave = (momentDate?.['_d'] as Date)?.getFullYear()
  const monthToSave = (momentDate?.['_d'] as Date)?.getMonth() + 1
  const dayToSave = (momentDate?.['_d'] as Date)?.getDate()

  if (!yearToSave || !monthToSave || !dayToSave) {
    return null
  }

  const dateToSave = `${yearToSave}-${monthToSave
    .toString()
    .padStart(2, '0')}-${dayToSave.toString()?.padStart(2, '0')}`

  return dateToSave
}
